(function ($) {
	$(
		'.box-navigation, .box-navigation-customer, .box-navigation-default'
		// @ts-ignore-next
	).stick_in_parent({
		offset_top: 125,
	});

	function highlightStickyNavItem(navigationTarget: string, module: string) {
		if ($(navigationTarget).length > 0 && $(module).length > 0) {
			$(window).scroll(function () {
				// Get the vertical scroll position
				var scrollPos = $(document).scrollTop();

				// Loop through each section to find the one in view
				$(module).each(function () {
					// We check that the module is not a gallery
					if (!$(this).hasClass('gallery')) {
						var currSection = $(this);
						var sectionId = currSection.attr('id');
						var sectionTop = currSection.offset().top - 250; // Adjust offset as needed

						if (scrollPos >= sectionTop) {
							// Remove the 'active' class from all navigation items
							$(navigationTarget + ' li a').removeClass(
								'is-active'
							);

							// Add the 'active' class to the corresponding navigation item
							if (
								$(
									navigationTarget +
										' navigation li:has(a[href="#' +
										sectionId +
										'"])'
								)
							) {
								$(
									navigationTarget +
										' li:has(a[href="#' +
										sectionId +
										'"]) a'
								).addClass('is-active');
							}
						}
					}
				});
			});
		}
	}
	highlightStickyNavItem('.box-navigation', '.module');
	highlightStickyNavItem('.box-navigation', '.category-module');

	function filtering() {
		$('.filtering-btn').on('click', function (e) {
			e.preventDefault();
		});
	}
	filtering();

	// slider on mobile
	function benefitSlider() {
		var sliderPlatform = $('.slider-benefit');

		var slider_options = {
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			dots: true,
			// @ts-ignore-next
			customPaging: function (slider, i) {
				return '<span class="slider-dot"></span>';
			},
			arrows: false,
			responsive: [
				{
					breakpoint: 960,
					settings: 'unslick',
				},
			],
		};

		// @ts-ignore-next
		slick_on_mobile(sliderPlatform, slider_options);

		// @ts-ignore-next
		function slick_on_mobile(slider, settings) {
			$(window).on('load resize orientationchange', function () {
				// @ts-ignore-next
				if ($(window).width() > 960) {
					if (slider.hasClass('slick-initialized')) {
						slider.slick('unslick');
					}
					return;
				}
				if (!slider.hasClass('slick-initialized')) {
					return slider.slick(settings);
				}
			});
		}
	}
	benefitSlider();

	// Smooth scrolling handles by css now. Commented out 2024-01-11
	// scroll event
	// function smooth() {
	// 	var header = $('.m-header');
	// 	// @ts-ignore-next
	// 	if ($(window).scrollTop() >= 85) {
	// 		header.addClass('scrolled');
	// 	} else {
	// 		header.removeClass('scrolled');
	// 	}
	// }
	// $(window).on('scroll', function () {
	// 	smooth();
	// });

	// menu mobile
	function menuMobile() {
		var btn = $('.btn-mobile'),
			btnSpan = $('.btn-mobile span'),
			menu = $('.menu-mobile'),
			link = $('.menu-top .megamenu > a'),
			link_dp = $('.menu-top .menu-item-has-children > a'),
			megaMenu = $('.menu-top .mega-menu'),
			subMenu = $('.menu-top .sub-menu'),
			switcher_mobile = $('.menu-bottom .menu-language li > a'),
			switcher_desktop = $(
				'.menu-desktop .menu-right .menu-language > li > a'
			);

		btn.on('click', function (e) {
			e.preventDefault();
			btnSpan.stop().toggleClass('x');
			menu.stop().toggleClass('block');
		});

		$(window).resize(function () {
			// @ts-ignore-next
			if ($(window).width() > 1279) {
				btnSpan.removeClass('x');
				menu.removeClass('block');
				link.removeClass('is-active');
				link_dp.removeClass('is-active');
				megaMenu.slideUp();
				subMenu.slideUp();
			}
		});

		link.on('click', function (e) {
			e.preventDefault();
			var el = $(this),
				isVisible = el.is('.is-active');

			link.removeClass('is-active');
			link_dp.removeClass('is-active');
			!isVisible ? el.addClass('is-active') : el.removeClass('is-active');
			megaMenu.slideUp();
			subMenu.slideUp();
			el.next('.mega-menu').stop().slideToggle();
		});

		link_dp.on('click', function (e) {
			e.preventDefault();
			var el = $(this),
				isVisible = el.is('.is-active');

			link.removeClass('is-active');
			link_dp.removeClass('is-active');
			!isVisible ? el.addClass('is-active') : el.removeClass('is-active');
			megaMenu.slideUp();
			subMenu.slideUp();
			el.next('.sub-menu').stop().slideToggle();
		});

		switcher_mobile.on('click', function () {
			var el = $(this),
				subMenu = el.next('.sub-menu');
			subMenu.stop().slideToggle();
		});

		switcher_desktop.on('click', function (e) {
			e.preventDefault();
		});
	}
	menuMobile();

	// Added twentythree check
	$('a.u-button, a.u-link').each(function () {
		// @ts-ignore-next
		if (
			$(this).attr('href').indexOf('wistia.net') !== -1 ||
			$(this).attr('href').indexOf('webinars.telavox.com') !== -1
		) {
			$(this).attr('data-lity', '');
		}
	});
})(jQuery);
